import { toSocialAnalytics } from '@engage/members/analytics';
import type { Member } from '@engage/members/models';

export const trackViewedAchievementsPage = ({
  member,
  sharedLeaderboardTag,
}: {
  member: Member;
  sharedLeaderboardTag: string | null;
}) => ({
  event: 'Viewed Achievements',
  ...toSocialAnalytics(member, sharedLeaderboardTag),
});
